import { ElementRef, AfterViewInit } from '@angular/core';
var LucideIconComponent = /** @class */ (function () {
    function LucideIconComponent(el) {
        this.el = el;
        this.name = '';
        this.size = 24;
        this.strokeWidth = 2;
        this.color = 'currentColor';
    }
    Object.defineProperty(LucideIconComponent.prototype, "kebabCaseName", {
        get: function () {
            return this.name
                .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
                .replace(/([A-Z])([A-Z][a-z])/g, '$1-$2')
                .toLowerCase();
        },
        enumerable: true,
        configurable: true
    });
    LucideIconComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (typeof lucide !== 'undefined' && lucide.createIcons) {
            setTimeout(function () {
                var iconElement = _this.el.nativeElement.querySelector('i');
                if (iconElement) {
                    if (_this.size) {
                        iconElement.style.width = _this.size + 'px';
                        iconElement.style.height = _this.size + 'px';
                    }
                    lucide.createIcons({
                        root: _this.el.nativeElement,
                        attrs: {
                            width: _this.size,
                            height: _this.size,
                            'stroke-width': _this.strokeWidth,
                            stroke: _this.color
                        }
                    });
                }
            }, 0);
        }
    };
    return LucideIconComponent;
}());
export { LucideIconComponent };
